<script lang="ts" setup>
const {
  closeNavigation,
} = useNavigation()
</script>

<template>
  <div class="navigation-header">
    <AppLogo class="navigation-header__logo" />

    <div class="navigation-header__entries" />

    <button
      class="navigation-header__close"
      :aria-label="$t('Close')"
      @click="closeNavigation"
    >
      <NuxtIcon name="icon:close" />
      <span class="navigation-header__close-label">{{ $t('Close') }}</span>
    </button>
  </div>
</template>

<style>
@import url("~layers/components/Navigation/Header.css");
</style>
